import { Injectable } from '@angular/core';
import { NavSlimLinks } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  BookWidgetAem,
  checkStringValueNull,
  MultiCitySearchCache,
  RetrieveSearch
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { TRIP_TYPES } from '../../constants/navigation-links/navigation-linkts-constants';
import {
  sanitizeMultiCityData,
  sanitizeRetrieveSearchData
} from '../../utils/header-slim/sanitization.utils';
import { HeaderSlimAdapterBaseService } from './header-slim-adapter-base.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderSlimAdapterService extends HeaderSlimAdapterBaseService {
  getContent(
    aem: BookWidgetAem,
    data: MultiCitySearchCache | RetrieveSearch[],
    selectTripType: string
  ): NavSlimLinks {
    return selectTripType === TRIP_TYPES.MULTICITY
      ? this.setMultiCityRecentResults(data as MultiCitySearchCache, aem)
      : this.setNonMultiCityRecentResults(data as RetrieveSearch[], aem);
  }

  setMultiCityRecentResults(
    data: MultiCitySearchCache,
    aem: BookWidgetAem
  ): NavSlimLinks {
    this.setTripTypeFlags(data?.value?.selectTripType);
    this.recentSearchData = sanitizeMultiCityData(data) as MultiCitySearchCache;

    const airports = this.recentSearchData?.value?.airports;
    const fromAirportCode = airports?.[0]?.fromAirportcode || '';
    const toAirportCode = airports?.[airports.length - 1]?.toAirportcode || '';
    const passenger = this.recentSearchData?.value?.passenger;

    return this.createNavSlimLinks(
      fromAirportCode,
      toAirportCode,
      passenger,
      aem
    );
  }

  setNonMultiCityRecentResults(
    data: RetrieveSearch[],
    aem: BookWidgetAem
  ): NavSlimLinks {
    const searchData = data?.[0];
    this.setTripTypeFlags(searchData?.selectTripType);
    this.recentSearchData = sanitizeRetrieveSearchData(searchData);

    const fromAirportCode =
      this.recentSearchData?.airports?.fromAirportcode || '';
    const toAirportCode = this.recentSearchData?.airports?.toAirportcode || '';
    const passenger = this.recentSearchData?.passenger;

    return this.createNavSlimLinks(
      fromAirportCode,
      toAirportCode,
      passenger,
      aem
    );
  }

  protected setTripTypeFlags(selectTripType: string): void {
    const tripType = checkStringValueNull(selectTripType)?.toUpperCase();
    this.tripTypeFlags = {
      isMultiCity: tripType === TRIP_TYPES.MULTICITY,
      isRoundTrip: tripType === TRIP_TYPES.ROUND_TRIP,
      isOneWay: tripType === TRIP_TYPES.ONE_WAY
    };
  }
}
